// @flow
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage, intlShape } from 'react-intl';
import { getLocalizedCountry } from "../../../local-values/utils/countries";
import ProductBase from '../../components/ProductBase/ProductBase';
import FeatureSelect from '../../components/FeatureSelect/FeatureSelect';
import classNames from 'classnames/bind';
import { Helmet } from "react-helmet";
import environment from '../../../../environment';
import { CommaFormat } from '../../../../elements/Price/Price';
import { Link } from 'react-router-dom';

import style from './Iphone.scss';
import featureStyle from '../../components/FeatureSelect/FeatureSelect.scss';
import logoApple from '../../../../assets/img/custom-products/iphone/apple-logo.png';
import iphoneBlack from '../../../../assets/img/custom-products/iphone/iphone_11_black.png';
import iphoneGold from '../../../../assets/img/custom-products/iphone/iphone_11_pro_gold.png';
import iphoneGreen from '../../../../assets/img/custom-products/iphone/iphone_11_green.png';
import iphoneMidnightGreen from '../../../../assets/img/custom-products/iphone/iphone_11_pro_midnight_green.png';
import iphoneSilver from '../../../../assets/img/custom-products/iphone/iphone_11_pro_silver.png';
import iphonePurple from '../../../../assets/img/custom-products/iphone/iphone_11_purple.png';
import iphoneRed from '../../../../assets/img/custom-products/iphone/iphone_11_red.png';
import iphoneSpaceGrey from '../../../../assets/img/custom-products/iphone/iphone_11_space_grey.png';
import iphoneWhite from '../../../../assets/img/custom-products/iphone/iphone_11_white.png';
import iphoneYellow from '../../../../assets/img/custom-products/iphone/iphone_11_yellow.png';

import iphoneSEWhite from '../../../../assets/img/custom-products/iphone/iphone_se_white.png';
import iphoneSEBlack from '../../../../assets/img/custom-products/iphone/iphone_se_black.png';
import iphoneSERed from '../../../../assets/img/custom-products/iphone/iphone_se_red.png';

import iphoneSEMidnight from '../../../../assets/img/custom-products/iphone/iphone_se_midnight.png';
import iphoneSEStarlight from '../../../../assets/img/custom-products/iphone/iphone_se_starlight.png';
import iphoneSEProductRed from '../../../../assets/img/custom-products/iphone/iphone_se_product_red.png';

import iphone12MiniWhite from '../../../../assets/img/custom-products/iphone/iphone_12_mini_white.png';
import iphone12MiniBlack from '../../../../assets/img/custom-products/iphone/iphone_12_mini_black.png';
import iphone12MiniBlue from '../../../../assets/img/custom-products/iphone/iphone_12_mini_blue.png';
import iphone12MiniGreen from '../../../../assets/img/custom-products/iphone/iphone_12_mini_green.png';
import iphone12MiniRed from '../../../../assets/img/custom-products/iphone/iphone_12_mini_red.png';
import iphone12MiniPurple from '../../../../assets/img/custom-products/iphone/iphone_12_mini_purple.png';
import iphone12White from '../../../../assets/img/custom-products/iphone/iphone_12_white.png';
import iphone12Black from '../../../../assets/img/custom-products/iphone/iphone_12_black.png';
import iphone12Blue from '../../../../assets/img/custom-products/iphone/iphone_12_blue.png';
import iphone12Green from '../../../../assets/img/custom-products/iphone/iphone_12_green.png';
import iphone12Red from '../../../../assets/img/custom-products/iphone/iphone_12_red.png';
import iphone12Purple from '../../../../assets/img/custom-products/iphone/iphone_12_purple.png';
import iphone12ProGraphite from '../../../../assets/img/custom-products/iphone/iphone_12_pro_graphite.png';
import iphone12ProSilver from '../../../../assets/img/custom-products/iphone/iphone_12_pro_silver.png';
import iphone12ProGold from '../../../../assets/img/custom-products/iphone/iphone_12_pro_gold.png';
import iphone12ProBlue from '../../../../assets/img/custom-products/iphone/iphone_12_pro_blue.png';
import iphone12ProMaxGraphite from '../../../../assets/img/custom-products/iphone/iphone_12_pro_max_graphite.png';
import iphone12ProMaxSilver from '../../../../assets/img/custom-products/iphone/iphone_12_pro_max_silver.png';
import iphone12ProMaxGold from '../../../../assets/img/custom-products/iphone/iphone_12_pro_max_gold.png';
import iphone12ProMaxBlue from '../../../../assets/img/custom-products/iphone/iphone_12_pro_max_blue.png';
import ipadPro11InchSpaceGrey from '../../../../assets/img/custom-products/iphone/ipad_11_inch_pro_space_grey.jpeg';
import ipadPro11InchSilver from '../../../../assets/img/custom-products/iphone/ipad_11_inch_pro_silver.jpeg';
import ipadPro129InchSpaceGrey from '../../../../assets/img/custom-products/iphone/ipad_12_9_inch_pro_space_grey.jpeg';
import ipadPro129InchSilver from '../../../../assets/img/custom-products/iphone/ipad_12_9_inch_pro_silver.jpeg';

import ipadAir109InchSpaceGrey from '../../../../assets/img/custom-products/iphone/ipad_10_9_inch_air_space_grey.png';
import ipadAir109InchPink from '../../../../assets/img/custom-products/iphone/ipad_10_9_inch_air_pink.png';
import ipadAir109InchPurple from '../../../../assets/img/custom-products/iphone/ipad_10_9_inch_air_purple.png';
import ipadAir109InchBlue from '../../../../assets/img/custom-products/iphone/ipad_10_9_inch_air_blue.png';
import ipadAir109InchStarlight from '../../../../assets/img/custom-products/iphone/ipad_10_9_inch_air_starlight.png';

import iphone13MiniGreen from '../../../../assets/img/custom-products/iphone/iphone_13_mini_green.png';
import iphone13MiniPink from '../../../../assets/img/custom-products/iphone/iphone_13_mini_pink.png';
import iphone13MiniBlue from '../../../../assets/img/custom-products/iphone/iphone_13_mini_blue.png';
import iphone13MiniMidnight from '../../../../assets/img/custom-products/iphone/iphone_13_mini_midnight.png';
import iphone13MiniStarlight from '../../../../assets/img/custom-products/iphone/iphone_13_mini_starlight.png';
import iphone13MiniRed from '../../../../assets/img/custom-products/iphone/iphone_13_mini_red.png';
import iphone13ProAlpineGreen from '../../../../assets/img/custom-products/iphone/iphone_13_pro_alpine_green.png';
import iphone13ProSierraBlue from '../../../../assets/img/custom-products/iphone/iphone_13_pro_sierra_blue.png';
import iphone13ProSilver from '../../../../assets/img/custom-products/iphone/iphone_13_pro_silver.png';
import iphone13ProGold from '../../../../assets/img/custom-products/iphone/iphone_13_pro_gold.png';
import iphone13ProGraphite from '../../../../assets/img/custom-products/iphone/iphone_13_pro_graphite.png';

import iphone14Blue from '../../../../assets/img/custom-products/iphone/iphone_14_blue.jpeg';
import iphone14BluePlus from '../../../../assets/img/custom-products/iphone/iphone_14_blue_plus.jpeg';
import iphone14Purple from '../../../../assets/img/custom-products/iphone/iphone_14_purple.jpeg';
import iphone14PurplePlus from '../../../../assets/img/custom-products/iphone/iphone_14_purple_plus.jpeg';
import iphone14Midnight from '../../../../assets/img/custom-products/iphone/iphone_14_midnight.jpeg';
import iphone14MidnightPlus from '../../../../assets/img/custom-products/iphone/iphone_14_midnight_plus.jpeg';
import iphone14Starlight from '../../../../assets/img/custom-products/iphone/iphone_14_starlight.jpeg';
import iphone14StarlightPlus from '../../../../assets/img/custom-products/iphone/iphone_14_starlight_plus.jpeg';
import iphone14Red from '../../../../assets/img/custom-products/iphone/iphone_14_red.jpeg';
import iphone14RedPlus from '../../../../assets/img/custom-products/iphone/iphone_14_red_plus.jpeg';

import iphone14DeepPurplePro from '../../../../assets/img/custom-products/iphone/iphone_14_deep_purple_pro.jpg';
import iphone14DeepPurpleProMax from '../../../../assets/img/custom-products/iphone/iphone_14_deep_purple_pro_max.jpg';
import iphone14GoldPro from '../../../../assets/img/custom-products/iphone/iphone_14_gold_pro.jpg';
import iphone14GoldProMax from '../../../../assets/img/custom-products/iphone/iphone_14_gold_pro_max.jpg';
import iphone14SilverPro from '../../../../assets/img/custom-products/iphone/iphone_14_silver_pro.jpg';
import iphone14SilverProMax from '../../../../assets/img/custom-products/iphone/iphone_14_silver_pro_max.jpg';
import iphone14SpaceBlackPro from '../../../../assets/img/custom-products/iphone/iphone_14_space_black_pro.jpg';
import iphone14SpaceBlackProMax from '../../../../assets/img/custom-products/iphone/iphone_14_space_black_pro_max.jpg';

import iphone15Img from '../../../../assets/img/custom-products/iphone/iphone_15.png';
import iphone16Img from '../../../../assets/img/custom-products/iphone/iphone_16.jpg';

import coverUSImg from '../../../../assets/img/home_meta_US_cover.png';
import coverPEImg from '../../../../assets/img/home_meta_PE_cover.png';
import coverCOImg from '../../../../assets/img/home_meta_CO_cover.png';

import type { LocaleState } from '../../../locale/duck';
import type { LocalValuesState } from '../../../local-values/duck';

type IPhone = {
  name: string;
  colors: string[];
  capacity: string[];
  images: { [key: string]: string };
  url: string;
  model?: string;
  modelLabel?: string;
  prices: { [key: string]: string };
  information?: { [key: string]: any };
  title: { [key: string]: string };
  description: { [key: string]: string };
  hasFeatures: boolean;
  preOrderDate?: string;
  comingSoon?: boolean;
};

type Props = {
  +locale: LocaleState;
  +localValues: LocalValuesState;
  +location: Location;
};

type State = {
  color: string;
  capacity: string;
  image: string;
  iphone: string;
};

const messages = defineMessages({
  capacityTitle: {
    partOne: { id: 'customProduct.iphone.capacity.title.one' },
    partTwo: { id: 'customProduct.iphone.capacity.title.two' },
  },
  capFrom: {
    id: 'customProduct.iphone.capacity.from',
  },
  detailTitle: { id: 'customProduct.iphone.detail.title' },
  whereTitle: {
    partOne: { id: 'customProduct.iphone.where.title.one' },
    partTwo: { id: 'customProduct.iphone.where.title.two' },
  },
  sizeTitle: {
    partOne: { id: 'customProduct.iphone.size.title.one' },
    partTwo: { id: 'customProduct.iphone.size.title.two' },
  },
});

const countriesImages = {
  US: coverUSImg,
  PE: coverPEImg,
  CO: coverCOImg,
};

const se = {
  // colors: ['white', 'black', 'red'],
  colors: ['midnight', 'starlight', 'red'],
  capacity: ['64', '128', '256'],
  url: 'https://www.apple.com/shop/buy-iphone/iphone-se',
  images: {    
    'midnight': `${environment.baseUrl['US']}${iphoneSEMidnight}`,
    'starlight': `${environment.baseUrl['US']}${iphoneSEStarlight}`,
    'red': `${environment.baseUrl['US']}${iphoneSEProductRed}`,
  },
};

const pro11 = {
  colors: ['space-gray', 'silver', 'midnight-green', 'gold'],
  capacity: ['64', '256', '512'],
  url: 'https://www.apple.com/shop/buy-iphone/iphone-11-pro',
  images: {
    'space-gray': `${environment.baseUrl['US']}${iphoneSpaceGrey}`,
    'silver': `${environment.baseUrl['US']}${iphoneSilver}`,
    'midnight-green': `${environment.baseUrl['US']}${iphoneMidnightGreen}`,
    'gold': `${environment.baseUrl['US']}${iphoneGold}`,
  },
};

const iphone12 = {
  colors: ['white', 'black', 'blue', 'green', 'red', 'purple'],
  capacity: ['64', '128', '256'],
  url: 'https://www.apple.com/shop/buy-iphone/iphone-12',
};

const iphone13 = {
  colors: ['green-nuevo', 'pink', 'blue', 'midnight', 'starlight', 'product-red'],
  capacity: ['128', '256', '512'],
  url: 'https://www.apple.com/shop/buy-iphone/iphone-13',
};

const iphone13Pro = {
  colors: ['alpine-green', 'sierra-blue', 'silver', 'gold', 'graphite'],
  capacity: ['128', '256', '512', '1024'],
  url: 'https://www.apple.com/shop/buy-iphone/iphone-13-pro',
};

const iphone14 = {
  colors: ['blue', 'purple', 'midnight', 'starlight', 'red'],
  capacity: ['128', '256', '512'],
  url: 'https://www.apple.com/shop/buy-iphone/iphone-14',
};

const iphone14Pro = {
  colors: ['deep-purple', 'gold', 'silver', 'space-black'],
  capacity: ['128', '256', '512', '1024'],
  url: 'https://www.apple.com/shop/buy-iphone/iphone-14-pro',
};

const iphonePro12 = {
  colors: ['graphite', 'silver', 'gold', 'pacific-blue'],
  capacity: ['128', '256', '512'],
  url: 'https://www.apple.com/shop/buy-iphone/iphone-12-pro',
}

const iphone15 = {
  /*colors: [],
  capacity: [],*/
  url: 'https://www.apple.com/shop/buy-iphone/iphone-15',
  // comingSoon: true,
  hasFeatures: true,
  // prices: {},
  /*images: {
    'deep-purple': `${environment.baseUrl['US']}${iphone15Img}`,
  },*/
  information: {
    detail: {
      PE: 'customProduct.iphone.detail.iphone15.content',
      CO: 'customProduct.iphone.detail.iphone15.content',
      US: 'customProduct.iphone.detail.iphone15.content',
    },
    where: {
      PE: 'customProduct.iphone.where.iphone15.content',
      CO: 'customProduct.iphone.where.iphone15.content',
      US: 'customProduct.iphone.where.iphone15.content',
    },
  },
  title: {
    PE: 'customProduct.iphone.title.iphone15',
    CO: 'customProduct.iphone.title.iphone15',
    US: 'customProduct.iphone.title.iphone15',
  },
  description: {
    PE: 'customProduct.iphone.description.iphone15',
    CO: 'customProduct.iphone.description.iphone15',
    US: 'customProduct.iphone.description.iphone15',
  },
};

const iphone16 = {
  /*colors: [],
  capacity: [],*/
  url: 'https://www.apple.com/shop/buy-iphone/iphone-16',
  // comingSoon: true,
  hasFeatures: true,
  // prices: {},
  /*images: {
    'infused-black': `${environment.baseUrl['US']}${iphone16Img}`,
  },*/
  information: {
    detail: {
      PE: 'customProduct.iphone.detail.iphone16.content',
      CO: 'customProduct.iphone.detail.iphone16.content',
      US: 'customProduct.iphone.detail.iphone16.content',
    },
    where: {
      PE: 'customProduct.iphone.where.iphone16.content',
      CO: 'customProduct.iphone.where.iphone16.content',
      US: 'customProduct.iphone.where.iphone16.content',
    },
  },
  title: {
    PE: 'customProduct.iphone.title.iphone16',
    CO: 'customProduct.iphone.title.iphone16',
    US: 'customProduct.iphone.title.iphone16',
  },
  description: {
    PE: 'customProduct.iphone.description.iphone16',
    CO: 'customProduct.iphone.description.iphone16',
    US: 'customProduct.iphone.description.iphone16',
  },
};

const iPhone12Pages = [
  // { name: '12 mini', url: '/custom-product/iphone-12-mini' },
  { name: '12', url: '/custom-product/iphone-12' },
  // { name: '12 Pro', url: '/custom-product/iphone-12-pro' },
  // { name: '12 Pro Max', url: '/custom-product/iphone-12-pro-max' },
]

const iPhone11Pages = [
  { name: '11', url: '/custom-product/iphone-11' },
  { name: '11 Pro', url: '/custom-product/iphone-11-pro' },
  { name: '11 Pro Max', url: '/custom-product/iphone-11-pro-max' },
];

/*const iPhone13Pages = [
  /!*{ name: '13 Mini', url: '/custom-product/iphone-13-mini' },*!/
  { name: '13', url: '/custom-product/iphone-13' },
  /!*{ name: '13 Pro', url: '/custom-product/iphone-13-pro' },
  { name: '13 Pro Max', url: '/custom-product/iphone-13-pro-max' },*!/
]*/

const iPhone14Pages = [
  { name: '14', url: '/custom-product/iphone-14' },
  { name: '14 Plus', url: '/custom-product/iphone-14-plus' },
  /*{ name: '14 Pro', url: '/custom-product/iphone-14-pro' },
  { name: '14 Pro Max', url: '/custom-product/iphone-14-pro-max' },*/
]

const iPhone15Pages = [
  { name: '15', url: '/custom-product/iphone-15' },
  { name: '15 Plus', url: '/custom-product/iphone-15-plus' },
  { name: '15 Pro', url: '/custom-product/iphone-15-pro' },
  { name: '15 Pro Max', url: '/custom-product/iphone-15-pro-max' },
]

const iPhone16Pages = [
  { name: '16', url: '/custom-product/iphone-16' },
  { name: '16 Plus', url: '/custom-product/iphone-16-plus' },
  { name: '16 Pro', url: '/custom-product/iphone-16-pro' },
  { name: '16 Pro Max', url: '/custom-product/iphone-16-pro-max' },
]

const ipadProPages = [
  { name: 'ipad pro 11-inch display Wi-Fi', display: '11-inch', conn: 'Wi-Fi', url: '/custom-product/ipad-pro-11-inch-wifi' },
  { name: 'ipad pro 11-inch display Wi-Fi + Cellular', display: '11-inch', conn: 'Wi-Fi + Cellular', url: '/custom-product/ipad-pro-11-inch-wifi-cell' },
  { name: 'ipad pro 12.9-inch display Wi-Fi', display: '12.9-inch', conn: 'Wi-Fi', url: '/custom-product/ipad-pro-12.9-inch-wifi' },
  { name: 'ipad pro 12.9-inch display Wi-Fi + Cellular', display: '12.9-inch', conn: 'Wi-Fi + Cellular', url: '/custom-product/ipad-pro-12.9-inch-wifi-cell' },
];
  
const iPadPro = {
  colors: ['space-gray', 'silver'],
  capacity: ['128', '256', '512', '1024', '2048'],
  url: 'https://www.apple.com/shop/buy-ipad/ipad-pro',
  name: 'iPad Pro',
  hasFeatures: true,
};

const iPadAirPages = [
  { name: 'ipad air 10.9-inch display Wi-Fi', display: '10.9-inch', conn: 'Wi-Fi', url: '/custom-product/ipad-air-10.9-inch-wifi' },
  { name: 'ipad air 10.9-inch display Wi-Fi + Cellular', display: '10.9-inch', conn: 'Wi-Fi + Cellular', url: '/custom-product/ipad-air-10.9-inch-wifi-cell' },
];

const iPadAir = {
  // colors: ['space-gray', 'silver', 'rose-gold', 'green', 'sky-blue'],
  colors: ['space-gray', 'pink', 'purple', 'blue', 'starlight'],
  capacity: ['64', '256'],
  url: 'https://www.apple.com/shop/buy-ipad/ipad-air',
  name: 'iPad Air',
  hasFeatures: true,
};

const iPhones: { [key: string]: IPhone } = {
  'iphone-se-2022': {
    ...se,
    name: 'iPhone SE 2022',
    model: '4.7-inch-display',
    modelLabel: '4.7" Retina HD display',
    prices: {
      '64': '429.00',
      '128': '479.00',
      '256': '579.00',
    },
    information: {
      detail: {
        PE: 'customProduct.iphone.detail.iphoneSE.content.PE',
        CO: 'customProduct.iphone.detail.iphoneSE.content.CO',
        US: 'customProduct.iphone.detail.iphoneSE.content.US',
      },
      where: {
        PE: 'customProduct.iphone.where.iphoneSE.content.PE',
        CO: 'customProduct.iphone.where.iphoneSE.content.CO',
        US: 'customProduct.iphone.where.iphoneSE.content.US',
      },
    },
    title: {
      PE: 'customProduct.iphone.title.iphoneSE.PE',
      CO: 'customProduct.iphone.title.iphoneSE.CO',
      US: 'customProduct.iphone.title.iphoneSE.US',
    },
    description: {
      PE: 'customProduct.iphone.description.iphoneSE.PE',
      CO: 'customProduct.iphone.description.iphoneSE.CO',
      US: 'customProduct.iphone.description.iphoneSE.US',
    },
    hasFeatures: false,
  },
  'iphone-11': {
    name: 'iPhone 11',
    model: '6.1-inch-display',
    modelLabel: '6.1" display',
    colors: ['white', 'black', 'green', 'yellow', 'purple', 'red'],
    capacity: ['64', '128'],
    url: 'https://www.apple.com/shop/buy-iphone/iphone-11',
    images: {
      'white': `${environment.baseUrl['US']}${iphoneWhite}`,
      'black': `${environment.baseUrl['US']}${iphoneBlack}`,
      'green': `${environment.baseUrl['US']}${iphoneGreen}`,
      'yellow': `${environment.baseUrl['US']}${iphoneYellow}`,
      'purple': `${environment.baseUrl['US']}${iphonePurple}`,
      'red': `${environment.baseUrl['US']}${iphoneRed}`,
    },
    prices: {
      '64': '499.00',
      '128': '549.00',
      // '256': '749.00',
    },
    information: {
      detail: {
        PE: 'customProduct.iphone.detail.iphone11.content.PE',
        CO: 'customProduct.iphone.detail.iphone11.content.CO',
        US: 'customProduct.iphone.detail.iphone11.content.US',
      },
      where: {
        PE: 'customProduct.iphone.where.iphone11.content.PE',
        CO: 'customProduct.iphone.where.iphone11.content.CO',
        US: 'customProduct.iphone.where.iphone11.content.US',
      },
    },
    title: {
      PE: 'customProduct.iphone.title.iphone11.PE',
      CO: 'customProduct.iphone.title.iphone11.CO',
      US: 'customProduct.iphone.title.iphone11.US',
    },
    description: {
      PE: 'customProduct.iphone.description.iphone11.PE',
      CO: 'customProduct.iphone.description.iphone11.CO',
      US: 'customProduct.iphone.description.iphone11.US',
    },
    hasFeatures: false,
  },
  'iphone-11-pro': {
    ...pro11,
    name: 'iPhone 11 Pro',
    model: '5.8-inch-display',
    modelLabel: '5.8" Display',
    prices: {
      '64': '999.00',
      '256': '1149.00',
      '512': '1349.00',
    },
    information: {
      detail: {
        PE: 'customProduct.iphone.detail.iphone11Pro.content.PE',
        CO: 'customProduct.iphone.detail.iphone11Pro.content.CO',
        US: 'customProduct.iphone.detail.iphone11Pro.content.US',
      },
      where: {
        PE: 'customProduct.iphone.where.iphone11Pro.content.PE',
        CO: 'customProduct.iphone.where.iphone11Pro.content.CO',
        US: 'customProduct.iphone.where.iphone11Pro.content.US',
      },
    },
    title: {
      PE: 'customProduct.iphone.title.iphone11Pro.PE',
      CO: 'customProduct.iphone.title.iphone11Pro.CO',
      US: 'customProduct.iphone.title.iphone11Pro.US',
    },
    description: {
      PE: 'customProduct.iphone.description.iphone11Pro.PE',
      CO: 'customProduct.iphone.description.iphone11Pro.CO',
      US: 'customProduct.iphone.description.iphone11Pro.US',
    },
    hasFeatures: true,
  },
  'iphone-11-pro-max': {
    ...pro11,
    name: 'iPhone 11 Pro Max',
    model: '6.5-inch-display',
    modelLabel: '6.5" Display',
    prices: {
      '64': '1099.00',
      '256': '1249.00',
      '512': '1449.00',
    },
    information: {
      detail: {
        PE: 'customProduct.iphone.detail.iphone11ProExtra.content.PE',
        CO: 'customProduct.iphone.detail.iphone11ProExtra.content.CO',
        US: 'customProduct.iphone.detail.iphone11ProExtra.content.US',
      },
      where: {
        PE: 'customProduct.iphone.where.iphone11ProExtra.content.PE',
        CO: 'customProduct.iphone.where.iphone11ProExtra.content.CO',
        US: 'customProduct.iphone.where.iphone11ProExtra.content.US',
      },
    },
    title: {
      PE: 'customProduct.iphone.title.iphone11ProMax.PE',
      CO: 'customProduct.iphone.title.iphone11ProMax.CO',
      US: 'customProduct.iphone.title.iphone11ProExtra.US',
    },
    description: {
      PE: 'customProduct.iphone.description.iphone11ProMax.PE',
      CO: 'customProduct.iphone.description.iphone11ProMax.CO',
      US: 'customProduct.iphone.description.iphone11ProExtra.US',
    },
    hasFeatures: true,
  },
  'ipad-pro-11-inch-wifi': {
    ...iPadPro,
    title: {
      PE: 'customProduct.iphone.title.ipadPro',
      CO: 'customProduct.iphone.title.ipadPro',
      US: 'customProduct.iphone.title.ipadPro',
    },
    description: {
      PE: 'customProduct.iphone.description.ipadPro',
      CO: 'customProduct.iphone.description.ipadPro',
      US: 'customProduct.iphone.description.ipadPro',
    },
    prices: {
      '128': '799.00',
      '256': '899.00',
      '512': '1099.00',
      '1024': '1499.00',
      '2048': '1899.00',
    },
    images: {
      'space-gray': `${environment.baseUrl['US']}${ipadPro11InchSpaceGrey}`,
      'silver': `${environment.baseUrl['US']}${ipadPro11InchSilver}`,
    },
  },
  'ipad-pro-11-inch-wifi-cell': {
    ...iPadPro,
    title: {
      PE: 'customProduct.iphone.title.ipadPro',
      CO: 'customProduct.iphone.title.ipadPro',
      US: 'customProduct.iphone.title.ipadPro',
    },
    description: {
      PE: 'customProduct.iphone.description.ipadPro',
      CO: 'customProduct.iphone.description.ipadPro',
      US: 'customProduct.iphone.description.ipadPro',
    },
    prices: {
      '128': '999.00',
      '256': '1099.00',
      '512': '1299.00',
      '1024': '1699.00',
      '2048': '2099.00',
    },
    images: {
      'space-gray': `${environment.baseUrl['US']}${ipadPro11InchSpaceGrey}`,
      'silver': `${environment.baseUrl['US']}${ipadPro11InchSilver}`,
    },
  },
  'ipad-pro-12.9-inch-wifi': {
    ...iPadPro,
    title: {
      PE: 'customProduct.iphone.title.ipadPro',
      CO: 'customProduct.iphone.title.ipadPro',
      US: 'customProduct.iphone.title.ipadPro',
    },
    description: {
      PE: 'customProduct.iphone.description.ipadPro',
      CO: 'customProduct.iphone.description.ipadPro',
      US: 'customProduct.iphone.description.ipadPro',
    },
    prices: {
      '128': '1099.00',
      '256': '1199.00',
      '512': '1399.00',
      '1024': '1799.00',
      '2048': '2199.00',
    },
    images: {
      'space-gray': `${environment.baseUrl['US']}${ipadPro129InchSpaceGrey}`,
      'silver': `${environment.baseUrl['US']}${ipadPro129InchSilver}`,
    },
  },
  'ipad-pro-12.9-inch-wifi-cell': {
    ...iPadPro,
    title: {
      PE: 'customProduct.iphone.title.ipadPro',
      CO: 'customProduct.iphone.title.ipadPro',
      US: 'customProduct.iphone.title.ipadPro',
    },
    description: {
      PE: 'customProduct.iphone.description.ipadPro',
      CO: 'customProduct.iphone.description.ipadPro',
      US: 'customProduct.iphone.description.ipadPro',
    },
    prices: {
      '128': '1299.00',
      '256': '1399.00',
      '512': '1599.00',
      '1024': '1999.00',
      '2048': '2399.00',
    },
    images: {
      'space-gray': `${environment.baseUrl['US']}${ipadPro129InchSpaceGrey}`,
      'silver': `${environment.baseUrl['US']}${ipadPro129InchSilver}`,
    },
  },
  'ipad-air-10.9-inch-wifi': {
    ...iPadAir,
    title: {
      PE: 'customProduct.iphone.title.ipadAir',
      CO: 'customProduct.iphone.title.ipadAir',
      US: 'customProduct.iphone.title.ipadAir',
    },
    description: {
      PE: 'customProduct.iphone.description.ipadAir',
      CO: 'customProduct.iphone.description.ipadAir',
      US: 'customProduct.iphone.description.ipadAir',
    },
    prices: {
      '64': '599.00',
      '256': '749.00',
    },
    images: {
      'space-gray': `${environment.baseUrl['US']}${ipadAir109InchSpaceGrey}`,
      'pink': `${environment.baseUrl['US']}${ipadAir109InchPink}`,
      'purple': `${environment.baseUrl['US']}${ipadAir109InchPurple}`,
      'blue': `${environment.baseUrl['US']}${ipadAir109InchBlue}`,
      'starlight': `${environment.baseUrl['US']}${ipadAir109InchStarlight}`,
    },
  },
  'ipad-air-10.9-inch-wifi-cell': {
    ...iPadAir,
    title: {
      PE: 'customProduct.iphone.title.ipadAir',
      CO: 'customProduct.iphone.title.ipadAir',
      US: 'customProduct.iphone.title.ipadAir',
    },
    description: {
      PE: 'customProduct.iphone.description.ipadAir',
      CO: 'customProduct.iphone.description.ipadAir',
      US: 'customProduct.iphone.description.ipadAir',
    },
    prices: {
      '64': '749.00',
      '256': '899.00',
    },
    images: {
      'space-gray': `${environment.baseUrl['US']}${ipadAir109InchSpaceGrey}`,
      'pink': `${environment.baseUrl['US']}${ipadAir109InchPink}`,
      'purple': `${environment.baseUrl['US']}${ipadAir109InchPurple}`,
      'blue': `${environment.baseUrl['US']}${ipadAir109InchBlue}`,
      'starlight': `${environment.baseUrl['US']}${ipadAir109InchStarlight}`,
    },
  },
  /*'iphone-12-mini': {
    ...iphone12,
    name: 'iPhone 12 mini',
    model: '5.4-inch-display',
    modelLabel: '5.4" Display',
    prices: {
      '64': '529.00',
      '128': '579.00',
      '256': '679.00',
    },
    images: {
      'white': `${environment.baseUrl['US']}${iphone12MiniWhite}`,
      'black': `${environment.baseUrl['US']}${iphone12MiniBlack}`,
      'blue': `${environment.baseUrl['US']}${iphone12MiniBlue}`,
      'green': `${environment.baseUrl['US']}${iphone12MiniGreen}`,
      'red': `${environment.baseUrl['US']}${iphone12MiniRed}`,
      'purple': `${environment.baseUrl['US']}${iphone12MiniPurple}`,
    },
    information: {
      detail: {
        PE: 'customProduct.iphone.detail.iphone12Mini.content.PE',
        CO: 'customProduct.iphone.detail.iphone12Mini.content.CO',
        US: 'customProduct.iphone.detail.iphone12Mini.content.US',
      },
      where: {
        PE: 'customProduct.iphone.where.iphone12Mini.content.PE',
        CO: 'customProduct.iphone.where.iphone12Mini.content.CO',
        US: 'customProduct.iphone.where.iphone12Mini.content.US',
      },
    },
    title: {
      PE: 'customProduct.iphone.title.iphone12Mini.PE',
      CO: 'customProduct.iphone.title.iphone12Mini.CO',
      US: 'customProduct.iphone.title.iphone12Mini.US',
    },
    description: {
      PE: 'customProduct.iphone.description.iphone12Mini.PE',
      CO: 'customProduct.iphone.description.iphone12Mini.CO',
      US: 'customProduct.iphone.description.iphone12Mini.US',
    },
    hasFeatures: true,
  },*/
  'iphone-12': {
    ...iphone12,
    name: 'iPhone 12',
    model: '6.1-inch-display',
    modelLabel: '6.1" Display',
    prices: {
      '64': '629.00',
      '128': '679.00',
      '256': '779.00',
    },
    images: {
      'white': `${environment.baseUrl['US']}${iphone12White}`,
      'black': `${environment.baseUrl['US']}${iphone12Black}`,
      'blue': `${environment.baseUrl['US']}${iphone12Blue}`,
      'green': `${environment.baseUrl['US']}${iphone12Green}`,
      'red': `${environment.baseUrl['US']}${iphone12Red}`,
      'purple': `${environment.baseUrl['US']}${iphone12Purple}`,
    },
    information: {
      detail: {
        PE: 'customProduct.iphone.detail.iphone12.content.PE',
        CO: 'customProduct.iphone.detail.iphone12.content.CO',
        US: 'customProduct.iphone.detail.iphone12.content.US',
      },
      where: {
        PE: 'customProduct.iphone.where.iphone12.content.PE',
        CO: 'customProduct.iphone.where.iphone12.content.CO',
        US: 'customProduct.iphone.where.iphone12.content.US',
      },
    },
    title: {
      PE: 'customProduct.iphone.title.iphone12.PE',
      CO: 'customProduct.iphone.title.iphone12.CO',
      US: 'customProduct.iphone.title.iphone12.US',
    },
    description: {
      PE: 'customProduct.iphone.description.iphone12.PE',
      CO: 'customProduct.iphone.description.iphone12.CO',
      US: 'customProduct.iphone.description.iphone12.US',
    },
    hasFeatures: true,
  },
  // 'iphone-12-pro': {
  //   ...iphonePro12,
  //   name: 'iPhone 12 Pro',
  //   model: '6.1-inch-display',
  //   modelLabel: '6.1" Display',
  //   prices: {
  //     '128': '999.00',
  //     '256': '1099.00',
  //     '512': '1299.00',
  //   },
  //   images: {
  //     'graphite': `${environment.baseUrl['US']}${iphone12ProGraphite}`,
  //     'silver': `${environment.baseUrl['US']}${iphone12ProSilver}`,
  //     'gold': `${environment.baseUrl['US']}${iphone12ProGold}`,
  //     'pacific-blue': `${environment.baseUrl['US']}${iphone12ProBlue}`,
  //   },
  //   information: {
  //     detail: {
  //       PE: 'customProduct.iphone.detail.iphone12Pro.content.PE',
  //       CO: 'customProduct.iphone.detail.iphone12Pro.content.CO',
  //       US: 'customProduct.iphone.detail.iphone12Pro.content.US',
  //     },
  //     where: {
  //       PE: 'customProduct.iphone.where.iphone12Pro.content.PE',
  //       CO: 'customProduct.iphone.where.iphone12Pro.content.CO',
  //       US: 'customProduct.iphone.where.iphone12Pro.content.US',
  //     },
  //   },
  //   title: {
  //     PE: 'customProduct.iphone.title.iphone12Pro.PE',
  //     CO: 'customProduct.iphone.title.iphone12Pro.CO',
  //     US: 'customProduct.iphone.title.iphone12Pro.US',
  //   },
  //   description: {
  //     PE: 'customProduct.iphone.description.iphone12Pro.PE',
  //     CO: 'customProduct.iphone.description.iphone12Pro.CO',
  //     US: 'customProduct.iphone.description.iphone12Pro.US',
  //   },
  //   hasFeatures: true,
  // },
  // 'iphone-12-pro-max': {
  //   ...iphonePro12,
  //   name: 'iPhone 12 Pro Max',
  //   model: '6.7-inch-display',
  //   modelLabel: '6.7" Display',
  //   prices: {
  //     '128': '1099.00',
  //     '256': '1199.00',
  //     '512': '1399.00',
  //   },
  //   images: {
  //     'graphite': `${environment.baseUrl['US']}${iphone12ProMaxGraphite}`,
  //     'silver': `${environment.baseUrl['US']}${iphone12ProMaxSilver}`,
  //     'gold': `${environment.baseUrl['US']}${iphone12ProMaxGold}`,
  //     'pacific-blue': `${environment.baseUrl['US']}${iphone12ProMaxBlue}`,
  //   },
  //   information: {
  //     detail: {
  //       PE: 'customProduct.iphone.detail.iphone12ProMax.content.PE',
  //       CO: 'customProduct.iphone.detail.iphone12ProMax.content.CO',
  //       US: 'customProduct.iphone.detail.iphone12ProMax.content.US',
  //     },
  //     where: {
  //       PE: 'customProduct.iphone.where.iphone12ProMax.content.PE',
  //       CO: 'customProduct.iphone.where.iphone12ProMax.content.CO',
  //       US: 'customProduct.iphone.where.iphone12ProMax.content.US',
  //     },
  //   },
  //   title: {
  //     PE: 'customProduct.iphone.title.iphone12ProMax.PE',
  //     CO: 'customProduct.iphone.title.iphone12ProMax.CO',
  //     US: 'customProduct.iphone.title.iphone12ProMax.US',
  //   },
  //   description: {
  //     PE: 'customProduct.iphone.description.iphone12ProMax.PE',
  //     CO: 'customProduct.iphone.description.iphone12ProMax.CO',
  //     US: 'customProduct.iphone.description.iphone12ProMax.US',
  //   },
  //   hasFeatures: true,
  // },
  /*'iphone-13-mini': {
    ...iphone13,
    name: 'iPhone 13 Mini',
    model: '5.4-inch-display',
    modelLabel: '5.4" Display',
    prices: {
      '128': '629.00',
      '256': '729.00',
      '512': '999.00',
    },
    information: {
      detail: {
        PE: 'customProduct.iphone.detail.iphone13Mini.content',
        CO: 'customProduct.iphone.detail.iphone13Mini.content',
        US: 'customProduct.iphone.detail.iphone13Mini.content',
      },
      where: {
        PE: 'customProduct.iphone.where.iphone13Mini.content',
        CO: 'customProduct.iphone.where.iphone13Mini.content',
        US: 'customProduct.iphone.where.iphone13Mini.content',
      },
    },
    images: {
      'green-nuevo': `${environment.baseUrl['US']}${iphone13MiniGreen}`,
      'pink': `${environment.baseUrl['US']}${iphone13MiniPink}`,
      'blue': `${environment.baseUrl['US']}${iphone13MiniBlue}`,
      'midnight': `${environment.baseUrl['US']}${iphone13MiniMidnight}`,
      'starlight': `${environment.baseUrl['US']}${iphone13MiniStarlight}`,
      'product-red': `${environment.baseUrl['US']}${iphone13MiniRed}`,
    },
    title: {
      PE: 'customProduct.iphone.title.iphone13Mini',
      CO: 'customProduct.iphone.title.iphone13Mini',
      US: 'customProduct.iphone.title.iphone13Mini',
    },
    description: {
      PE: 'customProduct.iphone.description.iphone13Mini',
      CO: 'customProduct.iphone.description.iphone13Mini',
      US: 'customProduct.iphone.description.iphone13Mini',
    },
    hasFeatures: true,
  },*/
  'iphone-13': {
    ...iphone13,
    name: 'iPhone 13',
    model: '6.1-inch-display',
    modelLabel: '6.1" Display',
    prices: {
      '128': '629.00',
      '256': '729.00',
      '512': '929.00',
    },
    information: {
      detail: {
        PE: 'customProduct.iphone.detail.iphone13.content',
        CO: 'customProduct.iphone.detail.iphone13.content',
        US: 'customProduct.iphone.detail.iphone13.content',
      },
      where: {
        PE: 'customProduct.iphone.where.iphone13.content',
        CO: 'customProduct.iphone.where.iphone13.content',
        US: 'customProduct.iphone.where.iphone13.content',
      },
    },
    images: {
      'green-nuevo': `${environment.baseUrl['US']}${iphone13MiniGreen}`,
      'pink': `${environment.baseUrl['US']}${iphone13MiniPink}`,
      'blue': `${environment.baseUrl['US']}${iphone13MiniBlue}`,
      'midnight': `${environment.baseUrl['US']}${iphone13MiniMidnight}`,
      'starlight': `${environment.baseUrl['US']}${iphone13MiniStarlight}`,
      'product-red': `${environment.baseUrl['US']}${iphone13MiniRed}`,
    },
    title: {
      PE: 'customProduct.iphone.title.iphone13',
      CO: 'customProduct.iphone.title.iphone13',
      US: 'customProduct.iphone.title.iphone13',
    },
    description: {
      PE: 'customProduct.iphone.description.iphone13',
      CO: 'customProduct.iphone.description.iphone13',
      US: 'customProduct.iphone.description.iphone13',
    },
    hasFeatures: true,
  },
  /*'iphone-13-pro': {
    ...iphone13Pro,
    name: 'iPhone 13 Pro',
    model: '6.1-inch-display',
    modelLabel: '6.1" Display',
    prices: {
      '128': '999.00',
      '256': '1099.00',
      '512': '1299.00',
      '1024': '1499.00',
    },
    information: {
      detail: {
        PE: 'customProduct.iphone.detail.iphone13Pro.content',
        CO: 'customProduct.iphone.detail.iphone13Pro.content',
        US: 'customProduct.iphone.detail.iphone13Pro.content',
      },
      where: {
        PE: 'customProduct.iphone.where.iphone13Pro.content',
        CO: 'customProduct.iphone.where.iphone13Pro.content',
        US: 'customProduct.iphone.where.iphone13Pro.content',
      },
    },
    images: {
      'alpine-green': `${environment.baseUrl['US']}${iphone13ProAlpineGreen}`,
      'sierra-blue': `${environment.baseUrl['US']}${iphone13ProSierraBlue}`,
      'silver': `${environment.baseUrl['US']}${iphone13ProSilver}`,
      'gold': `${environment.baseUrl['US']}${iphone13ProGold}`,
      'graphite': `${environment.baseUrl['US']}${iphone13ProGraphite}`,
    },
    title: {
      PE: 'customProduct.iphone.title.iphone13Pro',
      CO: 'customProduct.iphone.title.iphone13Pro',
      US: 'customProduct.iphone.title.iphone13Pro',
    },
    description: {
      PE: 'customProduct.iphone.description.iphone13Pro',
      CO: 'customProduct.iphone.description.iphone13Pro',
      US: 'customProduct.iphone.description.iphone13Pro',
    },
    hasFeatures: true,
  },
  'iphone-13-pro-max': {
    ...iphone13Pro,
    name: 'iPhone 13 Pro Max',
    model: '6.7-inch-display',
    modelLabel: '6.7" Display',
    prices: {
      '128': '1099.00',
      '256': '1199.000',
      '512': '1399.00',
      '1024': '1599.00',
    },
    images: {
      'alpine-green': `${environment.baseUrl['US']}${iphone13ProAlpineGreen}`,
      'sierra-blue': `${environment.baseUrl['US']}${iphone13ProSierraBlue}`,
      'silver': `${environment.baseUrl['US']}${iphone13ProSilver}`,
      'gold': `${environment.baseUrl['US']}${iphone13ProGold}`,
      'graphite': `${environment.baseUrl['US']}${iphone13ProGraphite}`,
    },
    title: {
      PE: 'customProduct.iphone.title.iphone13ProMax',
      CO: 'customProduct.iphone.title.iphone13ProMax',
      US: 'customProduct.iphone.title.iphone13ProMax',
    },
    description: {
      PE: 'customProduct.iphone.description.iphone13ProMax',
      CO: 'customProduct.iphone.description.iphone13ProMax',
      US: 'customProduct.iphone.description.iphone13ProMax',
    },
    hasFeatures: true,
  },*/
  'iphone-14': {
    ...iphone14,
    name: 'iPhone 14',
    model: '6.1-inch-display',
    modelLabel: '6.1" Display',
    prices: {
      '128': '729.00',
      '256': '829.00',
      '512': '1029.00',
    },
    information: {
      detail: {
        PE: 'customProduct.iphone.detail.iphone14.content',
        CO: 'customProduct.iphone.detail.iphone14.content',
        US: 'customProduct.iphone.detail.iphone14.content',
      },
      where: {
        PE: 'customProduct.iphone.where.iphone14.content',
        CO: 'customProduct.iphone.where.iphone14.content',
        US: 'customProduct.iphone.where.iphone14.content',
      },
    },
    images: {
      'blue': `${environment.baseUrl['US']}${iphone14Blue}`,
      'purple': `${environment.baseUrl['US']}${iphone14Purple}`,
      'midnight': `${environment.baseUrl['US']}${iphone14Midnight}`,
      'starlight': `${environment.baseUrl['US']}${iphone14Starlight}`,
      'red': `${environment.baseUrl['US']}${iphone14Red}`,
    },
    title: {
      PE: 'customProduct.iphone.title.iphone14',
      CO: 'customProduct.iphone.title.iphone14',
      US: 'customProduct.iphone.title.iphone14',
    },
    description: {
      PE: 'customProduct.iphone.description.iphone14',
      CO: 'customProduct.iphone.description.iphone14',
      US: 'customProduct.iphone.description.iphone14',
    },
    hasFeatures: true,
  },
  'iphone-14-plus': {
    ...iphone14,
    name: 'iPhone 14 Plus',
    model: '6.7-inch-display',
    modelLabel: '6.7" Display',
    prices: {
      '128': '829.00',
      '256': '929.00',
      '512': '1129.00',
    },
    information: {
      detail: {
        PE: 'customProduct.iphone.detail.iphone14.content',
        CO: 'customProduct.iphone.detail.iphone14.content',
        US: 'customProduct.iphone.detail.iphone14.content',
      },
      where: {
        PE: 'customProduct.iphone.where.iphone14.content',
        CO: 'customProduct.iphone.where.iphone14.content',
        US: 'customProduct.iphone.where.iphone14.content',
      },
    },
    images: {
      'blue': `${environment.baseUrl['US']}${iphone14BluePlus}`,
      'purple': `${environment.baseUrl['US']}${iphone14PurplePlus}`,
      'midnight': `${environment.baseUrl['US']}${iphone14MidnightPlus}`,
      'starlight': `${environment.baseUrl['US']}${iphone14StarlightPlus}`,
      'red': `${environment.baseUrl['US']}${iphone14RedPlus}`,
    },
    title: {
      PE: 'customProduct.iphone.title.iphone14',
      CO: 'customProduct.iphone.title.iphone14',
      US: 'customProduct.iphone.title.iphone14',
    },
    description: {
      PE: 'customProduct.iphone.description.iphone14',
      CO: 'customProduct.iphone.description.iphone14',
      US: 'customProduct.iphone.description.iphone14',
    },
    hasFeatures: true,
  },
  /*'iphone-14-pro': {
    ...iphone14Pro,
    name: 'iPhone 14 Pro',
    model: '6.1-inch-display',
    modelLabel: '6.1" Display',
    prices: {
      '128': '999.00',
      '256': '1099.00',
      '512': '1299.00',
      '1024': '1499.00',
    },
    information: {
      detail: {
        PE: 'customProduct.iphone.detail.iphone14.content',
        CO: 'customProduct.iphone.detail.iphone14.content',
        US: 'customProduct.iphone.detail.iphone14.content',
      },
      where: {
        PE: 'customProduct.iphone.where.iphone14.content',
        CO: 'customProduct.iphone.where.iphone14.content',
        US: 'customProduct.iphone.where.iphone14.content',
      },
    },
    images: {
      'deep-purple': `${environment.baseUrl['US']}${iphone14DeepPurplePro}`,
      'gold': `${environment.baseUrl['US']}${iphone14GoldPro}`,
      'silver': `${environment.baseUrl['US']}${iphone14SilverPro}`,
      'space-black': `${environment.baseUrl['US']}${iphone14SpaceBlackPro}`,
    },
    title: {
      PE: 'customProduct.iphone.title.iphone14',
      CO: 'customProduct.iphone.title.iphone14',
      US: 'customProduct.iphone.title.iphone14',
    },
    description: {
      PE: 'customProduct.iphone.description.iphone14',
      CO: 'customProduct.iphone.description.iphone14',
      US: 'customProduct.iphone.description.iphone14',
    },
    hasFeatures: true,
  },*/
  /*'iphone-14-pro-max': {
    ...iphone14Pro,
    name: 'iPhone 14 Pro Max',
    model: '6.7-inch-display',
    modelLabel: '6.7" Display',
    prices: {
      '128': '1099.00',
      '256': '1199.00',
      '512': '1399.00',
      '1024': '1599.00',
    },
    information: {
      detail: {
        PE: 'customProduct.iphone.detail.iphone14.content',
        CO: 'customProduct.iphone.detail.iphone14.content',
        US: 'customProduct.iphone.detail.iphone14.content',
      },
      where: {
        PE: 'customProduct.iphone.where.iphone14.content',
        CO: 'customProduct.iphone.where.iphone14.content',
        US: 'customProduct.iphone.where.iphone14.content',
      },
    },
    images: {
      'deep-purple': `${environment.baseUrl['US']}${iphone14DeepPurplePro}`,
      'gold': `${environment.baseUrl['US']}${iphone14GoldPro}`,
      'silver': `${environment.baseUrl['US']}${iphone14SilverPro}`,
      'space-black': `${environment.baseUrl['US']}${iphone14SpaceBlackPro}`,
    },
    title: {
      PE: 'customProduct.iphone.title.iphone14',
      CO: 'customProduct.iphone.title.iphone14',
      US: 'customProduct.iphone.title.iphone14',
    },
    description: {
      PE: 'customProduct.iphone.description.iphone14',
      CO: 'customProduct.iphone.description.iphone14',
      US: 'customProduct.iphone.description.iphone14',
    },
    hasFeatures: true,
  },*/
  'iphone-15': {
    ...iphone15,
    name: 'iPhone 15',
    model: '6.1-inch-display',
    modelLabel: '6.1" Display',
    colors: ['blue', 'pink', 'yellow', 'green', 'black'],
    capacity: ['128', '256', '512'],
    prices: {
      '128': '829.00',
      '256': '929.00',
      '512': '1129.00',
    },
    images: {
      'blue': 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/iphone-15-finish-select-202309-6-1inch-blue?wid=554&hei=312&fmt=p-jpg&qlt=80',
      'pink': 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/iphone-15-finish-select-202309-6-1inch-pink?wid=554&hei=312&fmt=p-jpg&qlt=80',
      'yellow': 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/iphone-15-finish-select-202309-6-1inch-yellow?wid=554&hei=312&fmt=p-jpg&qlt=80',
      'green': 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/iphone-15-finish-select-202309-6-1inch-green?wid=554&hei=312&fmt=p-jpg&qlt=80',
      'black': 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/iphone-15-finish-select-202309-6-1inch-black?wid=554&hei=312&fmt=p-jpg&qlt=80',
    },
  },
  'iphone-15-plus': {
    ...iphone15,
    name: 'iPhone 15 Plus',
    model: '6.7-inch-display',
    modelLabel: '6.7" Display',
    colors: ['blue', 'pink', 'yellow', 'green', 'black'],
    capacity: ['128', '256', '512'],
    prices: {
      '128': '929.00',
      '256': '1029.00',
      '512': '1229.00',
    },
    images: {
      'blue': 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/iphone-15-finish-select-202309-6-7inch-blue?wid=554&hei=312&fmt=p-jpg&qlt=80',
      'pink': 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/iphone-15-finish-select-202309-6-7inch-pink?wid=554&hei=312&fmt=p-jpg&qlt=80',
      'yellow': 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/iphone-15-finish-select-202309-6-7inch-yellow?wid=554&hei=312&fmt=p-jpg&qlt=80',
      'green': 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/iphone-15-finish-select-202309-6-7inch-green?wid=554&hei=312&fmt=p-jpg&qlt=80',
      'black': 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/iphone-15-finish-select-202309-6-7inch-black?wid=554&hei=312&fmt=p-jpg&qlt=80',
    },
  },
  'iphone-15-pro': {
    ...iphone15,
    name: 'iPhone 15 Pro',
    model: '6.1-inch-display',
    modelLabel: '6.1" Display',
    colors: ['natural-titanium', 'blue-titanium', 'white-titanium', 'black-titanium'],
    capacity: ['128', '256', '512', '1024'],
    prices: {
      '128': '999.00',
      '256': '1099.00',
      '512': '1299.00',
      '1024': '1499.00',
    },
    images: {
      'natural-titanium': 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/iphone-15-pro-finish-select-202309-6-1inch-naturaltitanium?wid=554&hei=312&fmt=p-jpg&qlt=80',
      'blue-titanium': 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/iphone-15-pro-finish-select-202309-6-1inch-bluetitanium?wid=554&hei=312&fmt=p-jpg&qlt=80',
      'white-titanium': 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/iphone-15-pro-finish-select-202309-6-1inch-whitetitanium?wid=554&hei=312&fmt=p-jpg&qlt=80',
      'black-titanium': 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/iphone-15-pro-finish-select-202309-6-1inch-blacktitanium?wid=554&hei=312&fmt=p-jpg&qlt=80',
    },
  },
  'iphone-15-pro-max': {
    ...iphone15,
    name: 'iPhone 15 Pro Max',
    model: '6.7-inch-display',
    modelLabel: '6.7" Display',
    colors: ['natural-titanium', 'blue-titanium', 'white-titanium', 'black-titanium'],
    capacity: ['256', '512', '1024'],
    prices: {
      '256': '1199.00',
      '512': '1399.00',
      '1024': '1599.00',
    },
    images: {
      'natural-titanium': 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/iphone-15-pro-finish-select-202309-6-7inch-naturaltitanium?wid=554&hei=312&fmt=p-jpg&qlt=80',
      'blue-titanium': 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/iphone-15-pro-finish-select-202309-6-7inch-bluetitanium?wid=554&hei=312&fmt=p-jpg&qlt=80',
      'white-titanium': 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/iphone-15-pro-finish-select-202309-6-7inch-whitetitanium?wid=554&hei=312&fmt=p-jpg&qlt=80',
      'black-titanium': 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/iphone-15-pro-finish-select-202309-6-7inch-blacktitanium?wid=554&hei=312&fmt=p-jpg&qlt=80',
    },
  },
  'iphone-16': {
    ...iphone16,
    name: 'iPhone 16',
    model: '6.1-inch-display',
    modelLabel: '6.1" Display',
    colors: ['ultramarine', 'teal', 'pink', 'white', 'black'],
    capacity: ['128', '256', '512'],
    prices: {
      '128': '829.00',
      '256': '929.00',
      '512': '1129.00',
    },
    images: {
      'ultramarine': 'https://store.storeimages.cdn-apple.com/1/as-images.apple.com/is/iphone-16-finish-select-202409-6-1inch-ultramarine?wid=5120&hei=2880&fmt=webp&qlt=70&.v=UXp1U3VDY3IyR1hNdHZwdFdOLzg1V0tFK1lhSCtYSGRqMUdhR284NTN4L28rSU1jVGx4VGxCNEFSdVNXdG1RdzJrQmVLSXFrTCsvY1VvVmRlZkVnMzJKTG1lVWJJT2RXQWE0Mm9rU1V0V0E5L1ZBdzY3RU1aTVdUR3lMZHFNVzE0RzhwM3RLeUk1S0YzTkJVVmF2Ly9RPT0=&traceId=1',
      'teal': 'https://store.storeimages.cdn-apple.com/1/as-images.apple.com/is/iphone-16-finish-select-202409-6-1inch-teal?wid=5120&hei=2880&fmt=webp&qlt=70&.v=UXp1U3VDY3IyR1hNdHZwdFdOLzg1V0tFK1lhSCtYSGRqMUdhR284NTN4L29KblRMQzVUOE4vMXpkMWtFcm9GcXF2TWlpSzUzejRCZGt2SjJUNGl1VEtsS0dZaHBma3VTb3UwU2F6dkc4TGRaWWVaY3B6VTFTdVNEWDF2OTRBYlY=&traceId=1',
      'pink': 'https://store.storeimages.cdn-apple.com/1/as-images.apple.com/is/iphone-16-finish-select-202409-6-1inch-pink?wid=5120&hei=2880&fmt=webp&qlt=70&.v=UXp1U3VDY3IyR1hNdHZwdFdOLzg1V0tFK1lhSCtYSGRqMUdhR284NTN4OUtONFJuV1pCdWVXaWp6ZXpQQi9FWXF2TWlpSzUzejRCZGt2SjJUNGl1VEtsS0dZaHBma3VTb3UwU2F6dkc4TGZqTWwxUjR3emtKcFNGYngyU0EvOWU=&traceId=1',
      'white': 'https://store.storeimages.cdn-apple.com/1/as-images.apple.com/is/iphone-16-finish-select-202409-6-1inch-white?wid=5120&hei=2880&fmt=webp&qlt=70&.v=UXp1U3VDY3IyR1hNdHZwdFdOLzg1V0tFK1lhSCtYSGRqMUdhR284NTN4OWhabGVFdVhnaExpMWhzbVh0SzhIT09MekhWSGZtV1pvV240QzNuTk80VXhseHVZcEw1SmhqcElaQkJMTm9FMytjRGRjd0V1bkY3a0xXbUtlY3VlTmc=&traceId=1',
      'black': 'https://store.storeimages.cdn-apple.com/1/as-images.apple.com/is/iphone-16-finish-select-202409-6-1inch-black?wid=5120&hei=2880&fmt=webp&qlt=70&.v=UXp1U3VDY3IyR1hNdHZwdFdOLzg1V0tFK1lhSCtYSGRqMUdhR284NTN4OUFsUUpuUVQ3cUdJUXc0NW5mTVpFdE9MekhWSGZtV1pvV240QzNuTk80VXhseHVZcEw1SmhqcElaQkJMTm9FMzlKVGsyNDdnTWJxWHVYZ20wTDc3dFA=&traceId=1',
    },
  },
  'iphone-16-plus': {
    ...iphone16,
    name: 'iPhone 16 Plus',
    model: '6.7-inch-display',
    modelLabel: '6.7" Display',
    colors: ['ultramarine', 'teal', 'pink', 'white', 'black'],
    capacity: ['128', '256', '512'],
    prices: {
      '128': '929.00',
      '256': '1029.00',
      '512': '1229.00',
    },
    images: {
      'ultramarine': 'https://store.storeimages.cdn-apple.com/1/as-images.apple.com/is/iphone-16-finish-select-202409-6-7inch-ultramarine?wid=5120&hei=2880&fmt=webp&qlt=70&.v=UXp1U3VDY3IyR1hNdHZwdFdOLzg1V0tFK1lhSCtYSGRqMUdhR284NTN4OUp1NDJCalJ6MnpHSm1KdCtRZ0FvSDJrQmVLSXFrTCsvY1VvVmRlZkVnMzJKTG1lVWJJT2RXQWE0Mm9rU1V0V0R3MDVyZ1JPeFp6dzlPbXNWQStmZHU2WXBMNDZGY1hQMjZ4S1VuNUdQZXF3PT0=&traceId=1',
      'teal': 'https://store.storeimages.cdn-apple.com/1/as-images.apple.com/is/iphone-16-finish-select-202409-6-7inch-teal?wid=5120&hei=2880&fmt=webp&qlt=70&.v=UXp1U3VDY3IyR1hNdHZwdFdOLzg1V0tFK1lhSCtYSGRqMUdhR284NTN4L0IwNTFtRWJyTEhXTVJ5VURtbkU2V3F2TWlpSzUzejRCZGt2SjJUNGl1VEtsS0dZaHBma3VTb3UwU2F6dkc4TGZjdkw1SitLU05OVzZDcmFNTzVKWC8=&traceId=1',
      'pink': 'https://store.storeimages.cdn-apple.com/1/as-images.apple.com/is/iphone-16-finish-select-202409-6-7inch-pink?wid=5120&hei=2880&fmt=webp&qlt=70&.v=UXp1U3VDY3IyR1hNdHZwdFdOLzg1V0tFK1lhSCtYSGRqMUdhR284NTN4OGNDaFdYdHQ0L2VyT2lVS3J0dUtUeHF2TWlpSzUzejRCZGt2SjJUNGl1VEtsS0dZaHBma3VTb3UwU2F6dkc4TGM0MVh6SDVyNjlYRjY0anVObGg5c1I=&traceId=1',
      'white': 'https://store.storeimages.cdn-apple.com/1/as-images.apple.com/is/iphone-16-finish-select-202409-6-7inch-white?wid=5120&hei=2880&fmt=webp&qlt=70&.v=UXp1U3VDY3IyR1hNdHZwdFdOLzg1V0tFK1lhSCtYSGRqMUdhR284NTN4L2JhVVdqaTJRWXhaTUQrck5qRnZDNE9MekhWSGZtV1pvV240QzNuTk80VXhseHVZcEw1SmhqcElaQkJMTm9FMy9oVnZkU1lmTld6YjN5K3Evc2MxaVg=&traceId=1',
      'black': 'https://store.storeimages.cdn-apple.com/1/as-images.apple.com/is/iphone-16-finish-select-202409-6-7inch-black?wid=5120&hei=2880&fmt=webp&qlt=70&.v=UXp1U3VDY3IyR1hNdHZwdFdOLzg1V0tFK1lhSCtYSGRqMUdhR284NTN4L2xJT1MvUkQrVjRwaXNCNlgyUGhDdU9MekhWSGZtV1pvV240QzNuTk80VXhseHVZcEw1SmhqcElaQkJMTm9FMytvWUZLSlNUOFVzSkZucG1HMDlET2c=&traceId=1',
    },
  },
  'iphone-16-pro': {
    ...iphone16,
    name: 'iPhone 16 Pro',
    model: '6.3-inch-display',
    modelLabel: '6.3" Display',
    colors: ['desert-titanium', 'natural-titanium', 'white-titanium', 'black-titanium'],
    capacity: ['128', '256', '512', '1024'],
    prices: {
      '128': '999.00',
      '256': '1099.00',
      '512': '1299.00',
      '1024': '1499.00',
    },
    images: {
      'desert-titanium': 'https://store.storeimages.cdn-apple.com/1/as-images.apple.com/is/iphone-16-pro-finish-select-202409-6-3inch-deserttitanium?wid=5120&hei=2880&fmt=webp&qlt=70&.v=eUdsd0dIb3VUOXdtWkY0VFUwVE8vbEdkZHNlSjBQRklnaFB2d3I5MW94Nm1neGR3bXRIczEyZHc4WTk0RkR4VEY3eHJKR1hDaEJCS2hmc2czazlldHlSTUMybCtXNXZpclhWeFpYZUcvRk80dEcwRGlZdHZNUlUyQVJ1QXFtSFFsOE8xQ2Rxc3QzeElocmgrcU1DbFJnPT0=&traceId=1',
      'natural-titanium': 'https://store.storeimages.cdn-apple.com/1/as-images.apple.com/is/iphone-16-pro-finish-select-202409-6-3inch-naturaltitanium?wid=5120&hei=2880&fmt=webp&qlt=70&.v=eUdsd0dIb3VUOXdtWkY0VFUwVE8vbEdkZHNlSjBQRklnaFB2d3I5MW94NVJrY0tZVVQzOFFrQ2FwbFZZamEzeEpOZTBYalh5Vk90cEc1K2wwRzFGejRMeXJHUnUva2huMjl4akFHOXNwVjA0YXFmK3VWSWZuRE9oVEFyUFR0T2hWSm5HQVhUeDlTTVJFSzVnTlpqdUV3PT0=&traceId=1',
      'white-titanium': 'https://store.storeimages.cdn-apple.com/1/as-images.apple.com/is/iphone-16-pro-finish-select-202409-6-3inch-whitetitanium?wid=5120&hei=2880&fmt=webp&qlt=70&.v=eUdsd0dIb3VUOXdtWkY0VFUwVE8vbEdkZHNlSjBQRklnaFB2d3I5MW94NkppVHhtRktGckFBd2ZPSmpuTHdJcWlCQmV2WTA2cncybDF2YzFnKzI0S2prMCtUNWwzYWR0UVU3TWVsbEdUeXZka3Q2dVFYV2lxTm4wNXBJcGZoM1QzVmtFSHJkUURvdVZmQktGTnNPd1Z3PT0=&traceId=1',
      'black-titanium': 'https://store.storeimages.cdn-apple.com/1/as-images.apple.com/is/iphone-16-pro-finish-select-202409-6-3inch-blacktitanium?wid=5120&hei=2880&fmt=webp&qlt=70&.v=eUdsd0dIb3VUOXdtWkY0VFUwVE8vbEdkZHNlSjBQRklnaFB2d3I5MW94NzFzS1BRRzA4NTJUci9vckVTY21rM2lCQmV2WTA2cncybDF2YzFnKzI0S2prMCtUNWwzYWR0UVU3TWVsbEdUeXZka3Q2dVFYV2lxTm4wNXBJcGZoM1RkcERRMUVIWTBwNlRNS3dVelNTTTVBPT0=&traceId=1',
    },
  },
  'iphone-16-pro-max': {
    ...iphone16,
    name: 'iPhone 16 Pro Max',
    model: '6.9-inch-display',
    modelLabel: '6.9" Display',
    colors: ['desert-titanium', 'natural-titanium', 'white-titanium', 'black-titanium'],
    capacity: ['256', '512', '1024'],
    prices: {
      '256': '1199.00',
      '512': '1399.00',
      '1024': '1599.00',
    },
    images: {
      'desert-titanium': 'https://store.storeimages.cdn-apple.com/1/as-images.apple.com/is/iphone-16-pro-finish-select-202409-6-9inch-deserttitanium?wid=5120&hei=2880&fmt=webp&qlt=70&.v=eUdsd0dIb3VUOXdtWkY0VFUwVE8vbEdkZHNlSjBQRklnaFB2d3I5MW94NW9lRVVkRmJ5ZE03VysydEdnMXpSNEY3eHJKR1hDaEJCS2hmc2czazlldHlSTUMybCtXNXZpclhWeFpYZUcvRk80dEcwRGlZdHZNUlUyQVJ1QXFtSFFUeEZnNlNyc3llcmZiYmQ5TGppeHJ3PT0=&traceId=1',
      'natural-titanium': 'https://store.storeimages.cdn-apple.com/1/as-images.apple.com/is/iphone-16-pro-finish-select-202409-6-9inch-naturaltitanium?wid=5120&hei=2880&fmt=webp&qlt=70&.v=eUdsd0dIb3VUOXdtWkY0VFUwVE8vbEdkZHNlSjBQRklnaFB2d3I5MW94NkkwYXJHRXdBd0xZTDNUS0M2eUNlY0pOZTBYalh5Vk90cEc1K2wwRzFGejRMeXJHUnUva2huMjl4akFHOXNwVjA0YXFmK3VWSWZuRE9oVEFyUFR0T2h6UkM0eXdTUkFqNnFqYk5ZcGUzV2tBPT0=&traceId=1',
      'white-titanium': 'https://store.storeimages.cdn-apple.com/1/as-images.apple.com/is/iphone-16-pro-finish-select-202409-6-9inch-whitetitanium?wid=5120&hei=2880&fmt=webp&qlt=70&.v=eUdsd0dIb3VUOXdtWkY0VFUwVE8vbEdkZHNlSjBQRklnaFB2d3I5MW94NVZBWnFueTF0UVNJeGtTZTdkUklJWmlCQmV2WTA2cncybDF2YzFnKzI0S2prMCtUNWwzYWR0UVU3TWVsbEdUeXZka3Q2dVFYV2lxTm4wNXBJcGZoM1RtRngzMXVwQnlNRVZFUUhmek1wL0NRPT0=&traceId=1',
      'black-titanium': 'https://store.storeimages.cdn-apple.com/1/as-images.apple.com/is/iphone-16-pro-finish-select-202409-6-9inch-blacktitanium?wid=5120&hei=2880&fmt=webp&qlt=70&.v=eUdsd0dIb3VUOXdtWkY0VFUwVE8vbEdkZHNlSjBQRklnaFB2d3I5MW94NlcvVjg4Q2h4WWRjcFAyYlBrM0N1bGlCQmV2WTA2cncybDF2YzFnKzI0S2prMCtUNWwzYWR0UVU3TWVsbEdUeXZka3Q2dVFYV2lxTm4wNXBJcGZoM1Rqb3p6Q2ZyUTlqTERzaHFUOVhnZGR3PT0=&traceId=1'
    },
  }
};

export default class Iphone extends Component<Props, State> {
  state = {
    color: '',
    capacity: '',
    image: '',
    iphone: '',
  };
  iPhone: IPhone;
  pathname: string;

  constructor(props: Props) {
    super(props);
    const pathname = props.location.pathname.split('/');
    this.pathname = pathname[2];

    switch (this.pathname) {
      case 'iphone-11-colombia':
      case 'iphone-11-peru':
        this.iPhone = iPhones['iphone-11'];
        break;
      case 'iphone-11-pro-colombia':
      case 'iphone-11-pro-peru':
        this.iPhone = iPhones['iphone-11-pro'];
        break;
      case 'iphone-11-pro-max-colombia':
      case 'iphone-11-pro-max-peru':
        this.iPhone = iPhones['iphone-11-pro-max'];
        break;
      case 'iphone-se-2022-colombia':
      case 'iphone-se-2022-peru':
        this.iPhone = iPhones['iphone-se-2022'];
        break;
      case 'iphone-12-mini':
        this.iPhone = iPhones['iphone-12-mini'];
        break;
      case 'iphone-12':
        this.iPhone = iPhones['iphone-12'];
        break;
      case 'iphone-12-pro':
        this.iPhone = iPhones['iphone-12-pro'];
        break;
      case 'iphone-12-pro-max':
        this.iPhone = iPhones['iphone-12-pro-max'];
        break;
      case 'ipad-pro-11-inch-wifi':
        this.iPhone = iPhones['ipad-pro-11-inch-wifi'];
        break;
      case 'ipad-pro-11-inch-wifi-cell':
        this.iPhone = iPhones['ipad-pro-11-inch-wifi-cell'];
        break;
      case 'ipad-pro-12.9-inch-wifi':
        this.iPhone = iPhones['ipad-pro-12.9-inch-wifi'];
        break;
      case 'ipad-pro-12.9-inch-wifi-cell':
        this.iPhone = iPhones['ipad-pro-12.9-inch-wifi-cell'];
        break;
      case 'ipad-air-10.9-inch-wifi':
        this.iPhone = iPhones['ipad-air-10.9-inch-wifi'];
        break;
      case 'ipad-air-10.9-inch-wifi-cell':
        this.iPhone = iPhones['ipad-air-10.9-inch-wifi-cell'];
        break;
      case 'iphone-13-mini':
        this.iPhone = iPhones['iphone-13-mini'];
        break;
      case 'iphone-13':
        this.iPhone = iPhones['iphone-13'];
        break;
      case 'iphone-13-pro':
        this.iPhone = iPhones['iphone-13-pro'];
        break;
      case 'iphone-13-pro-max':
        this.iPhone = iPhones['iphone-13-pro-max'];
        break;
      case 'iphone-14':
        this.iPhone = iPhones['iphone-14'];
        break;
      case 'iphone-14-plus':
        this.iPhone = iPhones['iphone-14-plus'];
        break;
      case 'iphone-14-pro':
        this.iPhone = iPhones['iphone-14-pro'];
        break;
      case 'iphone-14-pro-max':
        this.iPhone = iPhones['iphone-14-pro-max'];
        break;
      case 'iphone-15':
        this.iPhone = iPhones['iphone-15'];
        break;
      case 'iphone-15-plus':
        this.iPhone = iPhones['iphone-15-plus'];
        break;
      case 'iphone-15-pro':
        this.iPhone = iPhones['iphone-15-pro'];
        break;
      case 'iphone-15-pro-max':
        this.iPhone = iPhones['iphone-15-pro-max'];
        break;
      case 'iphone-16':
        this.iPhone = iPhones['iphone-16'];
        break;
      case 'iphone-16-plus':
        this.iPhone = iPhones['iphone-16-plus'];
        break;
      case 'iphone-16-pro':
        this.iPhone = iPhones['iphone-16-pro'];
        break;
      case 'iphone-16-pro-max':
        this.iPhone = iPhones['iphone-16-pro-max'];
        break;
    }
  }

  componentDidMount() {
    this.setState({
      color: this.iPhone.colors[0],
      capacity: this.iPhone.capacity[0],
      image: this.iPhone.images[Object.keys(this.iPhone.images)[0]],
      iphone: this.iPhone.name.split('iPhone ')[1],
    });
  }

  processCapacity(capacity: string): string {
    let cap = capacity;

    if (capacity) {
      cap = `${capacity} GB`;
      if (capacity === '1024') {
        cap = '1 TB';
      }
      if (capacity === '2048') {
        cap = '2 TB';
      }
    }
    
    return cap;
  }

  handleChangeColor = (value: string) => {
    this.setState({
      color: value,
      image: this.iPhone.images[value],
    });
  };

  handleChangeIphone = (value: string) => (
    this.setState({
      iphone: value,
    })
  );

  handleChangeCapacity = (value: string) => {
    this.setState({ capacity: value });
  };

  calculatePrice(capacity: string) {
    return this.iPhone.prices[capacity];
  }

  buildUrl = () => {
    const { capacity, color } = this.state;
    
    const cap = capacity ? this.processCapacity(capacity).toLowerCase().replace(' ', '') : '';

    if (this.iPhone.name.includes('iPad Pro')) {
      // https://www.apple.com/shop/buy-ipad/ipad-pro/11-inch-display-128gb-space-gray-wifi
      // https://www.apple.com/shop/buy-ipad/ipad-pro/11-inch-display-128gb-space-gray-wifi-cellular
      if (this.pathname.includes('11')) {
        if (this.pathname.includes('cell')) {
          return `${this.iPhone.url}/11-inch-display-${cap}-${color}-wifi-cellular`;
        }
        return `${this.iPhone.url}/11-inch-display-${cap}-${color}-wifi`;
      } else if (this.pathname.includes('12')) {
        if (this.pathname.includes('cell')) {
          return `${this.iPhone.url}/12.9-inch-display-${cap}-${color}-wifi-cellular`;
        }
        return `${this.iPhone.url}/12.9-inch-display-${cap}-${color}-wifi`;
      }
    }
    if (this.iPhone.name.includes('iPad Air')) {
      if (this.pathname.includes('cell')) {
        return `${this.iPhone.url}/${cap}-${color}-wifi-cellular`;
      }
      return `${this.iPhone.url}/${cap}-${color}-wifi`;
    }
    
    if (this.iPhone.model) {
      const m = this.iPhone.model;
      
      if (this.iPhone.name.toLowerCase().includes('pro')) {
        if (this.iPhone.name.toLowerCase().includes('15')) {
          return `${this.iPhone.url}-pro/${m}-${cap}-${color}-unlocked`;
        }
        // return `${this.iPhone.url}/${m}-${capacity}-${color}-unlocked`;
        return `${this.iPhone.url}/${m}-${cap}-${color}-unlocked`;
      } else if (this.iPhone.name.toLowerCase().includes('se')) {
        // return `${this.iPhone.url}/${m}-${capacity}${units}-${color}-unlocked`;
        return `${this.iPhone.url}/${m}-${cap}-${color}-unlocked`;
      } else {
        // return `${this.iPhone.url}/${m}-${capacity}${units}-${color}-unlocked`;
        return `${this.iPhone.url}/${m}-${cap}-${color}-unlocked`;
      }
    }
    return '';
  };

  buildInformation = () => {
    const { locale, localValues } = this.props;
    
    const x = this.iPhone.information;
    
    if (!x) return undefined;

    return [
      {
        title: `${this.context.intl.formatMessage(messages.detailTitle)} ${this.iPhone.name}`,
        text: `${this.context.intl.formatMessage({ id: x.detail[locale.domainCountry || 'PE'] })}`,
      },
      {
        title: `${this.context.intl.formatMessage(messages.whereTitle.partOne)} ${this.iPhone.name}` +
          ` ${this.context.intl.formatMessage(messages.whereTitle.partTwo)}` +
          ` ${getLocalizedCountry(locale.domainCountry || 'PE', this.context.intl.formatMessage, localValues.countriesMap)}?`,
        text: `${this.context.intl.formatMessage({ id: x.where[locale.domainCountry || 'PE'] })}`,
      },
    ]
  };

  buildPreOrderInfo = (storeName: string) => this.iPhone.preOrderDate && (
    <FormattedMessage id={"customProduct.base.preOrder.text"}>{
      txt => <p className={style.preOrderText}>{txt} {storeName} {this.iPhone.preOrderDate}</p>
    }</FormattedMessage>);
  
  buildColorName = (color: string): string => {
    let c = color.replace('nuevo', '(Nuevo)');
    c = c.replace('-', ' ');
    return c;
  };

  render() {
    const { image, capacity, color, iphone } = this.state;
    const { locale } = this.props;
    const onlineStore = {
      id: 'ST08333814',
      logo: 'https://res.cloudinary.com/qempo/image/upload/v1551903426/static/stores/Apple.png',
      name: 'Apple',
      slug: 'apple',
      type: 'online - store',
      url: 'https://www.apple.com/',
    };

    const title = this.context.intl.formatMessage({ id: this.iPhone.title[locale.domainCountry || 'PE'] });
    const description = this.context.intl.formatMessage({ id: this.iPhone.description[locale.domainCountry || 'PE'] });
    const baseUrl = environment.baseUrl[locale.domainCountry || 'US'];
    const coverImg = countriesImages[locale.domainCountry || 'US'];
    
    const categoryId = this.iPhone.name.toLowerCase().includes('ipad') ? 11 : 3;
    
    // const preferredImportationMethod = this.pathname.includes('13') ? 'lite' : undefined;

    return (
      <Fragment>
        <Helmet meta={[
          { name: 'description', content: description },
          { property: 'og:image', content: `${baseUrl}${coverImg}` },
          { property: 'og:title', content: title },
          { property: 'og:description', content: description },
          { name: 'twitter:title', content: title },
          { name: 'twitter:twitter:image', content: `${baseUrl}${coverImg}` },
          { name: 'twitter:twitter:description', content: description },
        ]}>
          <title>{title}</title>
        </Helmet>
        <ProductBase name={this.iPhone.name}
                     image={image}
                     price={this.calculatePrice(capacity)}
                     store={{ image: logoApple, country: 'USA' }}
                     url={this.buildUrl()}
                     color={color}
                     capacity={capacity}
                     onlineStore={onlineStore}
                     categoryId={categoryId}
                     information={this.buildInformation()}
                     preOrderInfo={this.buildPreOrderInfo(onlineStore.name)}
                     preferredImportationMethod={undefined}
                     comingSoon={this.iPhone.comingSoon}
        >
          <section className={style.selectSize}>
            {this.iPhone.hasFeatures &&
            <p>{`${this.context.intl.formatMessage(messages.sizeTitle.partOne)} `} {this.iPhone.name}
              {` ${this.context.intl.formatMessage(messages.sizeTitle.partTwo)}:`}</p>}
            {/* size selector */}
            {this.iPhone.hasFeatures &&
            <FeatureSelect>
              {this.iPhone.name.includes('iPad Air') &&
              iPadAirPages.map((o: { [key: string]: string }, i: number) => (<Link key={'ipad-air-' + i}
                             to={o.url}
                             className={classNames({ 
                               [featureStyle.active]: 
                               this.pathname.includes('cell') ?
                                   this.pathname.includes(o.display) && o.conn.includes('Cell') :
                                   this.pathname.includes(o.display) && !o.conn.includes('Cell'),
                             })}
                             onClick={() => this.handleChangeIphone(o.name)}>
                  <p>{o.display}</p>
                  <p className={style.conn}>{o.conn}</p>
                </Link>
                )
              )}
              {this.iPhone.name.includes('iPad Pro') &&
              ipadProPages.map((o: { [key: string]: string }, i: number) => (<Link key={"ipad-pro-" + i}
                             to={o.url}
                             className={classNames({ 
                               [featureStyle.active]: 
                               this.pathname.includes('cell') ?
                                   this.pathname.includes(o.display) && o.conn.includes('Cell') :
                                   this.pathname.includes(o.display) && !o.conn.includes('Cell'),
                             })}
                             onClick={() => this.handleChangeIphone(o.name)}>
                  <p>{o.display}</p>
                  <p className={style.conn}>{o.conn}</p>
                </Link>
                )
              )}
              {this.iPhone.name.includes('11') &&
              iPhone11Pages.map((o: { [key: string]: string }, i: number) => (
                <Link key={i}
                      to={`${o.url}-${locale.domainCountry === 'CO' ? 'colombia' : 'peru'}`}
                      className={classNames({ [featureStyle.active]: o.name === iphone })}
                      onClick={() => this.handleChangeIphone(o.name)}>
                  <p>iPhone</p>
                  <p className={style.size}>{o.name}</p>
                </Link>))}
              {(this.iPhone.name.includes('12')) &&
              iPhone12Pages.map((o: { [key: string]: string }, i: number) => (
                <Link key={i}
                      to={o.url}
                      className={classNames({ [featureStyle.active]: o.name === iphone })}
                      onClick={() => this.handleChangeIphone(o.name)}>
                  <p>iPhone</p>
                  <p className={style.size}>{o.name}</p>
                </Link>))}
              {/*{(this.iPhone.name.includes('13')) &&
              iPhone13Pages.map((o: { [key: string]: string }, i: number) => (
                <Link key={i}
                      to={o.url}
                      className={classNames({ [featureStyle.active]: o.name === iphone })}
                      onClick={() => this.handleChangeIphone(o.name)}>
                  <p>iPhone</p>
                  <p className={style.size}>{o.name}</p>
                </Link>))}*/}
              {(this.iPhone.name.includes('14')) &&
              iPhone14Pages.map((o: { [key: string]: string }, i: number) => (
                <Link key={i}
                      to={o.url}
                      className={classNames({ [featureStyle.active]: o.name === iphone })}
                      onClick={() => this.handleChangeIphone(o.name)}>
                  <p>iPhone</p>
                  <p className={style.size}>{o.name}</p>
                </Link>))}
              {(this.iPhone.name.includes('15')) &&
                iPhone15Pages.map((o: { [key: string]: string }, i: number) => (
                  <Link key={i}
                        to={o.url}
                        className={classNames({ [featureStyle.active]: o.name === iphone })}
                        onClick={() => this.handleChangeIphone(o.name)}>
                    <p>iPhone</p>
                    <p className={style.size}>{o.name}</p>
                  </Link>))}
              {(this.iPhone.name.includes('16')) &&
                iPhone16Pages.map((o: { [key: string]: string }, i: number) => (
                  <Link key={i}
                        to={o.url}
                        className={classNames({ [featureStyle.active]: o.name === iphone })}
                        onClick={() => this.handleChangeIphone(o.name)}>
                    <p>iPhone</p>
                    <p className={style.size}>{o.name}</p>
                  </Link>))}
            </FeatureSelect>}
          </section>
          {!this.iPhone.comingSoon && (<section className={style.selectColor}>
            <FormattedMessage id="customProduct.iphone.color.title">{
              text => <p>{text}</p>
            }</FormattedMessage>
            {/* color selector*/}
            <FeatureSelect>
              {this.iPhone.colors.map((c: string, i: number) => (
                <article key={i} className={classNames({[featureStyle.active]: c === color})}
                         onClick={() => this.handleChangeColor(c)}>
                  <div className={classNames(style.circle, style[c])}/>
                  <p>{this.buildColorName(c)}</p>
                </article>))}
            </FeatureSelect>
          </section>)}
          {!this.iPhone.comingSoon && (<section className={style.selectCapacity}>
            <p>{`${this.context.intl.formatMessage(messages.capacityTitle.partOne)} `} {this.iPhone.name}
              {` ${this.context.intl.formatMessage(messages.capacityTitle.partTwo)}:`}</p>
            {/* capacity selector */}
            <FeatureSelect>
              {this.iPhone.capacity.map((c: string, i: number) => (
                <article key={i} className={classNames({ [featureStyle.active]: c === capacity })}
                         onClick={() => this.handleChangeCapacity(c)}>
                  <p className={style.capacity}>{this.processCapacity(c)}</p>
                  <p className={style.price}>
                    {`${this.context.intl.formatMessage(messages.capFrom)} `} {`$ ${CommaFormat({ price: this.calculatePrice(c) })}`}
                  </p>
                </article>))}
            </FeatureSelect>
          </section>)}
        </ProductBase>
      </Fragment>
    );
  }
}

Iphone.propTypes = {
  locale: PropTypes.object.isRequired,
  localValues: PropTypes.object.isRequired,
  location: PropTypes.object,
};

Iphone.contextTypes = {
  intl: intlShape,
};



// WEBPACK FOOTER //
// ./src/modules/custom-products/Iphone/components/Iphone.jsx